module.exports = "/images/vendor/desiigner-svg/svg/places/marker.svg?9a4bfd36fde20f965beef00eba4442bb";